// Global CSS first, so components' own styles load after it and can override it.
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import i18n from "./i18n";
import App from "./App";
import { languageFromPath } from "./contexts/Language";

i18n.changeLanguage(languageFromPath(window.location.pathname));

const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// scripts/prerender.js draws most pages into their HTML at build time and
// marks the path it drew. React takes over that markup when it's this path's;
// otherwise it draws the page itself: on the cart and order pages, which have
// none, and on unknown paths, which the hosting answers with the home page.
const container = document.getElementById("root");
if (container.dataset.pathname === window.location.pathname.replace(/(.)\/$/, "$1")) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
